<template>
    <p-form @submit="onSubmit">
        <div class="container-fluid content-wrapper" v-if="courseRequestBookStatus">
            <b-row class="content-heading">
                <b-col>
                    <div>{{ isNew ? 'Add' : 'Edit' }} Course Request Type</div>
                </b-col>
                <b-col cols="auto" class="ms-auto">
                    <b-button type="submit" variant="primary">Save</b-button>
                </b-col>
            </b-row>

            <p-card>
                <b-row cols="1" cols-lg="2">
                    <b-col>
                        <p-input
                            label="Name"
                            v-model="courseRequestBookStatus.name"
                            rules="required|max:50"
                            :disabled="courseRequestBookStatus.isSystem"
                            :info-message="courseRequestBookStatus.isSystem
                                ? 'This is a built-in course request type.  Its name is used by course imports and cannot be changed, but the abbreviation and active status can be modified.'
                                : null" />
                        <p-input
                            label="Abbreviation"
                            v-model="courseRequestBookStatus.abbreviation"
                            rules="required|max:20" />
                        <div style="margin-left: 14px;" class="mt-3 pb-4">
                            <p-checkbox
                                label="Active"
                                v-model="courseRequestBookStatus.isActive"
                                :use-switch="true" />
                        </div>
                    </b-col>
                </b-row>
            </p-card>
            <b-row>
                <b-col class="text-center">
                    <b-button variant="primary" type="submit">Save</b-button>
                </b-col>
            </b-row>
        </div>
    </p-form>
</template>

<script>
import axios from "axios";
import NavigationGuard from '@/components/mixins/NavigationGuard.js'
import editPage from '@/components/mixins/EditPage';

export default {
    mixins: [NavigationGuard, editPage],
    data() {
        return {
            courseRequestBookStatus: null
        };
    },
    watch: {
        courseRequestBookStatus: NavigationGuard.$watcher
    },
    methods: {
        onSubmit() {
            axios.post("courserequestbookstatus", this.courseRequestBookStatus)
                .then((response) => {
                    this.dataSaved();
                    if (this.isNew) {
                        this.$router.push("/courserequestbookstatus/" + response.data);
                    }
                    this.$appSuccess(`Course request type '${this.courseRequestBookStatus.name}' saved successfully.`);
                });
        },
        loadData() {
            let promise = this.isNew
                ? axios.get('courserequestbookstatus/new')
                : axios.get('courserequestbookstatus', { params: { id: this.id } });

            promise.then(resp => {
                this.courseRequestBookStatus = resp.data;
                if (!this.isNew) {
                    this.dataLoaded();
                }
            });
        }
    },
    mounted: function() {
        this.loadData();
    }
};
</script>
